<div>
    <div>
        <h5 class="c-label">Filter Header</h5>
        <div class="row">
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">Background Color</label></div>
                    <div
                        class="input-group"
                        [(colorPicker)]="sharedService.filterSetup.header.backgroundColor"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                    >
                        <input id="headerBackgroundColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="sharedService.filterSetup.header.backgroundColor"
                            class="c-c-form-group__input form-control"
                        />

                        <div class="input-group-append">
                            <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': sharedService.filterSetup.header.backgroundColor }"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerFontColor">Font Color</label></div>
                    <div
                        class="input-group"
                        [(colorPicker)]="sharedService.filterSetup.header.fontColor"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'left'"
                    >
                        <input id="headerFontColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="sharedService.filterSetup.header.fontColor"
                            class="c-c-form-group__input form-control"
                        />

                        <div class="input-group-append">
                            <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': sharedService.filterSetup.header.fontColor }"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="fontStyle">Font Style</label></div>
                    <ccl-simple-select formId="fontStyle"
                        [listOfItems]="sharedService.fontStyles"
                        (valueChange)="sharedService.filterSetup.header.fontStyle = $event.value"
                        [value]="sharedService.filterSetup.header.fontStyle"
                        [bindValue]="'id'"
                        [bindLabel]="'label'"
                        [isClearable]="false"
                    ></ccl-simple-select>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="fontSize">Font Size</label></div>
                    <ccl-simple-select formId="fontSize"
                        [listOfItems]="sharedService.fontSizesSmall"
                        (valueChange)="sharedService.filterSetup.header.fontSize = $event.value"
                        [value]="sharedService.filterSetup.header.fontSize"
                    ></ccl-simple-select>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
        </div>
    </div>

    <div>
        <h5 class="c-label">Filter Body</h5>
        <div class="row">
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="bodyBackgroundColor">Background Color</label></div>
                    <div
                        class="input-group"
                        [(colorPicker)]="sharedService.filterSetup.body.backgroundColor"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'top'"
                    >
                        <input id="bodyBackgroundColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="sharedService.filterSetup.body.backgroundColor"
                            class="c-c-form-group__input form-control"
                        />

                        <div class="input-group-append">
                            <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': sharedService.filterSetup.body.backgroundColor }"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="bodyFontColor">Font Color</label></div>
                    <div
                        class="input-group"
                        [(colorPicker)]="sharedService.filterSetup.body.fontColor"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'top'"
                    >
                        <input id="bodyFontColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="sharedService.filterSetup.body.fontColor"
                            class="c-c-form-group__input form-control"
                        />

                        <div class="input-group-append">
                            <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': sharedService.filterSetup.body.fontColor }"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="selectionMachanism">Font Style</label></div>
                    <ccl-simple-select ariaLabel="Font style"
                        [listOfItems]="sharedService.fontStyles"
                        (valueChange)="sharedService.filterSetup.body.fontStyle = $event.value"
                        [value]="sharedService.filterSetup.body.fontStyle"
                        [bindValue]="'id'"
                        [bindLabel]="'label'"
                        [isClearable]="false"
                    ></ccl-simple-select>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">Font Size</label></div>
                    <ccl-simple-select ariaLabel="Font size"
                        [listOfItems]="sharedService.fontSizesSmall"
                        (valueChange)="sharedService.filterSetup.body.fontSize = $event.value"
                        [value]="sharedService.filterSetup.body.fontSize"
                        [bindValue]="'id'"
                        [bindLabel]="'label'"
                    ></ccl-simple-select>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
        </div>
    </div>

    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="c-form-group__label"><h5 class="c-label">Expansion Style</h5></div>
                <ccl-simple-select ariaLabel="Expansion Style"
                    [listOfItems]="expansionStyles"
                    (valueChange)="sharedService.filterSetup.expansionStyles = $event.value"
                    [value]="sharedService.filterSetup.expansionStyles"
                    [bindValue]="'id'"
                    [bindLabel]="'label'"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>
</div>
